var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleteProfileDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_3996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13637 16.8574C1.22421 16.8574 1.30171 16.8574 1.37406 16.8574C3.9008 16.8574 6.42755 16.8574 8.9543 16.8574C9.0163 16.8574 9.08348 16.8574 9.14548 16.8574C9.37284 16.8735 9.52269 17.0298 9.52785 17.2507C9.53302 17.4715 9.38317 17.6385 9.15582 17.6601C9.12481 17.6655 9.09381 17.6601 9.05764 17.6601C6.21053 17.6601 3.35825 17.6601 0.511137 17.6601C0.464633 17.6601 0.423295 17.6601 0.356122 17.6601C0.350955 17.5847 0.345788 17.52 0.345788 17.4554C0.299283 14.0074 1.78226 11.4915 4.62421 9.80526C5.04275 9.55744 5.48712 9.3581 5.9315 9.15338C6.00901 9.11567 6.13819 9.12644 6.2157 9.16415C7.77101 9.97765 9.32117 9.98304 10.8713 9.15877C10.9798 9.09951 11.0677 9.09951 11.1762 9.1426C11.8686 9.42814 12.5455 9.73522 13.1345 10.2201C13.3102 10.3655 13.3619 10.5487 13.2844 10.7319C13.212 10.8989 13.0415 10.9959 12.871 10.9582C12.7935 10.942 12.716 10.8989 12.6488 10.845C12.2148 10.5056 11.7342 10.2416 11.2279 10.0423C11.1348 10.01 11.0108 10.0046 10.923 10.0423C9.3315 10.7534 7.75035 10.7588 6.16402 10.0315C6.10202 10.0046 6.00901 9.99382 5.947 10.0208C4.43819 10.7211 3.13606 11.6855 2.22147 13.1508C1.54457 14.2337 1.21387 15.4351 1.13637 16.7173C1.1312 16.7604 1.13637 16.7981 1.13637 16.8574Z",
    fill: "#29BCC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56708 0.560913C10.7011 0.560913 12.4321 2.37647 12.427 4.61224C12.4218 6.84263 10.6805 8.63663 8.53608 8.63125C6.41237 8.62586 4.68137 6.81569 4.68653 4.59069C4.6917 2.36031 6.42271 0.560913 8.56708 0.560913ZM8.56708 1.36902C6.85158 1.36902 5.46161 2.80207 5.46161 4.5853C5.45644 6.37392 6.84125 7.82314 8.54641 7.82852C10.2619 7.83391 11.6519 6.39547 11.6519 4.61224C11.6571 2.81824 10.2774 1.36902 8.56708 1.36902Z",
    fill: "#29BCC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2958 15.1994C16.2958 17.1445 14.7873 18.6994 12.9529 18.6994C11.1185 18.6994 9.61006 17.1445 9.61006 15.1994C9.61006 13.2544 11.1185 11.6994 12.9529 11.6994C14.7873 11.6994 16.2958 13.2544 16.2958 15.1994Z",
    stroke: "#19B3B5",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 15.2L12.4127 16.4667L14.5711 13.9333",
    stroke: "#19B3B5",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_3996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteProfileDash);
export default __webpack_public_path__ + "static/media/complete-profile-dash.e7f87ccfca32319ed28a11e22b2bb268.svg";
export { ForwardRef as ReactComponent };